import React, { FunctionComponent, useState, Dispatch } from "react";
import { connect, ConnectedProps } from "react-redux";
import SearchInput from "../common/Form/SearchInput";
import { addFriend } from "../../redux/actions/FriendsActions";
import { setUserNameInfo } from "../../redux/actions/UserNameActions";
import ExpansionFriendRequests from "./ExpansionFriendRequests";
import { database } from "../../App";
import UserIcon from "../profile/UserIcon";
import {
  ProfileInterface,
  ProfileInfo
} from "../../redux/reducers/ProfileReducers";
import {
  FriendsInterface,
  friendActionInterface
} from "../../redux/reducers/FriendsReducers";
import { AuthInterface } from "../../redux/reducers/AuthReducers";
import {
  UserNamesInterface,
  userNamesActionInterface
} from "../../redux/reducers/UserNameReducers";

interface actionsType {
  addFriend: (
    otherUserId: string,
    otherUserUserName: string,
    currentUserName: string
  ) => (dispatch: Dispatch<friendActionInterface>) => void;
  setUserNameInfo: (
    user: ProfileInfo
  ) => (dispatch: Dispatch<userNamesActionInterface>) => void;
}
interface RootState {
  profile: ProfileInterface;
  friends: FriendsInterface;
  auth: AuthInterface;
  usernames: UserNamesInterface;
}

const actionsReducers: actionsType = {
  addFriend,
  setUserNameInfo
};

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
  profile: state.profile,
  friends: state.friends,
  usernames: state.usernames
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface FriendsProps {}

interface resultsInterface {
  value?: any;
  text?: string;
  type?: string;
}

const Friends: FunctionComponent<FriendsProps & PropsFromRedux> = props => {
  const [search, setSearch] = useState("jfbahamondes2");
  const [results, setResults] = useState({} as resultsInterface);
  const [isShowingRequestSent, setIsShowingRequestSent] = useState(false);
  const [isShowingRequestReceived, setIsShowingRequestReceived] = useState(
    false
  );
  const [isShowingAllFriends, setIsShowingAllFriends] = useState(false);

  function addFriend(username: string) {
    if (props.usernames.info && props.profile.info) {
      props.addFriend(
        props.usernames.info[username].uid,
        username,
        props.profile.info.username
      );
      setSearch("");
      setResults({
        text: undefined,
        value: undefined,
        type: undefined
      });
    }
  }

  function searchFriend(e: any) {
    if (e.key === "Enter") {
      if (props.profile.info?.username === search) {
        return setResults({
          text: "You will be always you eternal friend.",
          type: "you"
        });
      }

      try {
        if (props.usernames.info && props.usernames.info[search]) {
          setFriendsResults(props.usernames.info[search]);
        } else {
          setResults({
            text: "Loading...",
            type: "searching"
          });
          database
            .ref("usernames")
            .child(search)
            .on("value", snapshot => {
              if (snapshot.val()) {
                database
                  .ref("users")
                  .child(snapshot.val().uid)
                  .child("profile")
                  .on("value", snapshot2 => {
                    setFriendsResults(snapshot2.val());
                    props.setUserNameInfo(snapshot2.val());
                  });
              } else {
                setResults({
                  text: "Could not find that username",
                  type: "not found"
                });
              }
            });
        }
      } catch (e) {
        setResults({
          text: "Could not find that username",
          type: "not found"
        });
      }
    }
  }

  function renderResults() {
    if (props.friends.adding_friend) {
      return <div style={{ marginBottom: 20 }}>Adding Friend</div>;
    }
    if (props.friends.deleting_friend_request) {
      return <div style={{ marginBottom: 20 }}>Canceling Friend Request</div>;
    }
    switch (results.type) {
      case "add friend":
        return (
          <div style={{ marginBottom: 20 }} className="card">
            <div className="card-body">
              <div className="card-title jsa">
                <span>
                  <UserIcon
                    url={results.value.userpic}
                    height="40"
                    width="40"
                  />{" "}
                  @{results.value.username}
                </span>
                <span
                  onClick={() => addFriend(results.value.username)}
                  className="btn btn-success"
                >
                  +
                </span>
              </div>
              <p className="card-text">
                You will have to wait until he/she accepts you
              </p>
            </div>
          </div>
        );
      case "not found":
      case "you":
      case "searching":
        return <div style={{ marginBottom: 20 }}>{results.text}</div>;

      default:
        return (
          <div style={{ marginBottom: 20 }}>
            {results.type} {results.text}
          </div>
        );
    }
  }

  function onChangeSearch(event: any) {
    setSearch(event.target.value.replace("@", ""));
  }

  function setFriendsResults(result: any) {
    if (
      props.friends.info?.friend_requests_sent.data &&
      props.friends.info.friend_requests_sent.data[search]
    ) {
      setResults({
        value: result,
        type: "friend request sent"
      });
    } else if (
      props.friends.info?.friend_requests_received.data &&
      props.friends.info.friend_requests_received.data[search]
    ) {
      setResults({
        value: result,
        type: "friend request received"
      });
    } else if (
      props.friends.info?.friends.data &&
      props.friends.info.friends.data[search]
    ) {
      setResults({
        value: result,
        type: "friend"
      });
    } else {
      setResults({
        value: result,
        type: "add friend"
      });
    }
  }

  function renderFriends() {
    if (props.friends.loading) {
      return <div>Loading Info...</div>;
    } else {
      return (
        <div>
          <br />
          <SearchInput
            onChange={onChangeSearch}
            placeholder="Search by username.."
            onKeyDown={searchFriend}
            value={search}
          />
          <br />
          {renderResults()}

          <ExpansionFriendRequests
            isExpanded={isShowingAllFriends}
            onChange={() => setIsShowingAllFriends(!isShowingAllFriends)}
            title="All"
            requests={
              props.friends.info
                ? props.friends.info?.friends
                : {
                    count: 0,
                    data: {}
                  }
            }
            message="You don't have any friend yet"
            type="all_friends"
          />

          <ExpansionFriendRequests
            isExpanded={isShowingRequestSent}
            onChange={() => setIsShowingRequestSent(!isShowingRequestSent)}
            title="Requests Sent"
            requests={
              props.friends.info
                ? props.friends.info.friend_requests_sent
                : {
                    count: 0,
                    data: {}
                  }
            }
            message="You don't have any request yet"
            type="requests_sent"
          />

          <ExpansionFriendRequests
            isExpanded={isShowingRequestReceived}
            onChange={() =>
              setIsShowingRequestReceived(!isShowingRequestReceived)
            }
            title="Requests Received"
            requests={
              props.friends.info
                ? props.friends.info.friend_requests_received
                : {
                    count: 0,
                    data: {}
                  }
            }
            message="You don't have any request yet"
            type="requests_received"
          />
        </div>
      );
    }
  }
  return (
    <div>
      <h4>Friends</h4>
      {renderFriends()}
    </div>
  );
};

export default connector(Friends);
